import { inject, Injectable } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';

import { DsModalService } from '@design-system/ds-base-modal/services/ds-modal.service';
import { CustomerEditModalComponent } from '../component/customer-edit-modal.component';
import { CustomerEditModalDataInterface, CustomerEditModalResult } from '../interfaces/customer-edit-modal-data.interface';
import { CUSTOMER_EDIT_MODAL_WIDTH } from '../properties/customer-edit-modal.properties';

@Injectable({
  providedIn: 'root',
})
export class CustomerEditModalService {
  private readonly dsModalService = inject(DsModalService);

  /**
   * Opens the add/edit customer modal.
   *
   * @returns `'refresh'` when the customer was saved, `undefined` when the user closed the modal.
   */
  openDialog$(modalData: CustomerEditModalDataInterface): Observable<CustomerEditModalResult> {
    const dialogRef: MatDialogRef<CustomerEditModalComponent, CustomerEditModalResult> = this.dsModalService.open<
      CustomerEditModalComponent,
      CustomerEditModalDataInterface,
      CustomerEditModalResult
    >(CustomerEditModalComponent, {
      data: modalData,
      width: CUSTOMER_EDIT_MODAL_WIDTH,
    });

    return dialogRef.afterClosed();
  }
}
